


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ButtonGreen',
})
/**
 * @group Atomic/Atoms
 * ButtonGreen component
 */
export default class ButtonGreen extends Vue {
  // [prop]
  // [type] is type of green button
  @Prop({ type: String, default: 'normal' }) type!: string;

  // [text] is button text
  @Prop({ type: String, required: true }) text!: string;

  // [clickAction] is function when click
  @Prop({ type: Function, required: true }) clickAction!: Function;
}
